import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessCheckService } from '@lyceo/homi-dashboard/user/data-access';
import { map } from 'rxjs';

export function roleGuard(
  redirectUrl: string[],
  allowedRoles: string[],
): CanActivateFn {
  return () => {
    const router: Router = inject(Router);
    const accessCheckService: AccessCheckService = inject(AccessCheckService);

    return accessCheckService.hasRequiredRole(allowedRoles).pipe(
      map((hasRole: boolean) => {
        if (hasRole) {
          return true;
        }
        return router.createUrlTree(redirectUrl);
      }),
    );
  };
}
